import { b as subDays } from './util3.js';
import { a as addDays, c as subMonths, s as startOfMonth } from './index13.js';

/**
 * Note that by default our presets exclude today, so we start with 'yesterday' instead of 'today'
 */
const getDateRangePresets = (excludeToday = true) => {
    const today = new Date();
    const yesterday = subDays(today, 1);
    const end = excludeToday ? yesterday : today;
    const start = excludeToday ? today : addDays(today, 1);
    return {
        YESTERDAY: {
            label: 'Yesterday',
            value: () => [yesterday, yesterday],
        },
        '7_DAYS': {
            label: 'Last 7 days',
            value: () => [subDays(start, 7), end],
        },
        '14_DAYS': {
            label: 'Last 14 days',
            value: () => [subDays(start, 14), end],
        },
        '30_DAYS': {
            label: 'Last 30 days',
            value: () => [subDays(start, 30), end],
        },
        '60_DAYS': {
            label: 'Last 60 days',
            value: () => [subDays(start, 60), end],
        },
        '90_DAYS': {
            label: 'Last 90 days',
            value: () => [subDays(start, 90), end],
        },
        '12_MONTHS': {
            label: 'Last 12 months',
            value: () => [subMonths(start, 12), end],
        },
        '24_MONTHS': {
            label: 'Last 24 months',
            value: () => [subMonths(start, 24), end],
        },
        '60_MONTHS': {
            label: 'Last 60 months',
            value: () => [subMonths(start, 60), end],
        },
        MONTH_TO_DATE: {
            label: 'Month to date',
            value: () => [startOfMonth(new Date()), end],
        },
        CUSTOM: {
            label: 'Custom',
            value: () => [null, null],
        },
    };
};

export { getDateRangePresets as g };

//# sourceMappingURL=constants.js.map